import type { ComputeModalResourceKind } from './types';

export const COMPUTE_RESOURCE_MODAL_TITLE: Record<ComputeModalResourceKind, string> = {
  cpu: 'CPU配置',
  memory: '内存配置',
  gpu: 'GPU配置',
};

export const COMPUTE_RESOURCE_ADD_LABEL: Record<ComputeModalResourceKind, string> = {
  cpu: 'CPU配置',
  memory: '内存配置',
  gpu: 'GPU配置',
};

export const COMPUTE_RESOURCE_ICON: Record<ComputeModalResourceKind, string> = {
  cpu: 'icon-cpu',
  memory: 'icon-memory',
  gpu: 'icon-GPU',
};
